.av{flex:1;}